import { config } from '@helpers/config';
import { createRoute, ROUTES } from '@helpers/routeDefinitions';
import { useUserService } from '@hooks/useUser/useUser';
import MainLayout from '@layouts/main-layout/main-layout';
import { AbsoluteCenteredLoading } from '@minds/minds-react-sdk';
import ErrorBoundary from '@pages/public/error-boundary';
import React, { Suspense, useEffect } from 'react';
import {
    createBrowserRouter,
    Navigate,
    RouterProvider,
} from 'react-router-dom';

const LoginLayout = React.lazy(() => import('@layouts/login-layout'));
const AuthenticatedLayout = React.lazy(
    () => import('@layouts/authenticated-layout'),
);

const permissionRoutes = [
    {
        path: '/',
        errorElement: <ErrorBoundary />,
        element: <MainLayout />,
        children: [
            createRoute(ROUTES.PUBLIC),
            createRoute(ROUTES.NOT_FOUND),
            {
                element: <LoginLayout />,
                children: [
                    createRoute(ROUTES.LOGIN),
                    createRoute(ROUTES.COMPANY_LOGIN),
                    createRoute(ROUTES.FORGOT_COMPANY_NAME),
                    createRoute(ROUTES.FORGOT_PASSWORD),
                    createRoute(ROUTES.RESET_PASSWORD),
                    createRoute(ROUTES.OAUTH_LOGIN),
                ],
            },
            {
                element: <AuthenticatedLayout />,
                children: [
                    createRoute(ROUTES.TRIAL),
                    createRoute(ROUTES.DASHBOARD),
                    createRoute(ROUTES.SEARCH),
                    createRoute(ROUTES.FLAGS),
                    createRoute(ROUTES.CASES),
                    createRoute(ROUTES.CUSTOMERS),
                    createRoute(ROUTES.SILENCED_LIST),
                    createRoute(ROUTES.EDIT_PROFILE),
                    createRoute(ROUTES.WATCHLISTS),
                    createRoute(ROUTES.REPORTS),
                    createRoute(ROUTES.CONFIG),
                ],
            },
            {
                path: '*',
                element: <Navigate replace to={ROUTES.NOT_FOUND.path} />,
            },
        ],
    },
];

const router = createBrowserRouter(permissionRoutes, {
    basename: config.baseUrl,
});

export default function WebportalRoutes() {
    return (
        <>
            <UserLoggedInProvider />

            <Suspense fallback={<AbsoluteCenteredLoading size="4x" />}>
                <RouterProvider
                    router={router}
                    fallbackElement={<AbsoluteCenteredLoading size="4x" />}
                />
            </Suspense>
        </>
    );
}

function UserLoggedInProvider() {
    const userService = useUserService();

    useEffect(() => {
        void userService.ensurePicturesLoaded();
    }, []);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
}
